import React from "react";
import MicRoundedIcon from "@mui/icons-material/MicRounded";
import { formatSeconds } from "./useWebVoiceRecorder";

/**
 * Кнопка «надиктовать» и полоска записи (как в чате): идёт запись — таймер,
 * «Отмена» и «Готово». recorder — результат useWebVoiceRecorder().
 */
export default function VoiceRecordBar({ recorder, onFinished, label = "Голосом", disabled = false, compact = false, title }) {
    if (recorder.recording) {
        return (
            <div className="office-task-voice-bar-AO is-recording">
                <span className="office-task-voice-bar-AO__pulse" />
                <b>Запись {formatSeconds(recorder.seconds)}</b>
                <button type="button" className="is-ghost" onClick={() => recorder.cancel()}>Отмена</button>
                <button
                    type="button"
                    onClick={async () => {
                        const voice = await recorder.finish();
                        if (voice) onFinished(voice);
                    }}
                >
                    Готово
                </button>
            </div>
        );
    }

    return (
        <button
            type="button"
            className={`office-task-voice-bar-AO__mic ${compact ? "is-compact" : ""}`}
            disabled={disabled}
            onClick={() => recorder.start()}
            title={title || "Надиктовать голосом — текст появится сам после расшифровки"}
            aria-label={label}
        >
            <MicRoundedIcon sx={{ fontSize: compact ? 19 : 17 }} />
            {compact ? null : <span>{label}</span>}
        </button>
    );
}
